import { Routes } from '@angular/router';

/**
 * Rutas raíz: autenticación (`auth`), admin (`admin`, lazy), público (`''`) y
 * fallback 404 (`**`). Cada dominio carga sus rutas hijas de forma diferida.
 *
 * Gate de auth por superficie (no global): `auth` y `admin` montan
 * `AuthGateComponent` como componente padre — el spinner/error del bootstrap
 * de sesión solo gatea las superficies autenticadas (ambas
 * `RenderMode.Client`). El storefront público (`''`) cuelga directo del shell
 * raíz: el SSR de un visitante anónimo nunca instancia el gate ni dispara el
 * ciclo de vida de auth.
 *
 * Orden importante (S7 Fase B): `auth` y `admin` van ANTES que el dominio
 * público porque el storefront monta las rutas comodín `:typeKey/:slug` y
 * `:slug` — si el público matcheara primero, una URL como `/admin/cms` (o
 * `/admin` mismo, vía la ruta corta) caería en el detalle del storefront en
 * vez del admin. El wildcard `**` queda al final como 404 real (rutas con
 * más de dos segmentos que no existen).
 */
export const routes: Routes = [
  {
    path: 'auth',
    loadComponent: () =>
      import('@domains/auth/components/auth-gate/auth-gate.component').then(
        (m) => m.AuthGateComponent
      ),
    loadChildren: () =>
      import('@domains/auth/routes/auth.routes').then((m) => m.authRoutes),
  },
  {
    path: 'admin',
    loadComponent: () =>
      import('@domains/auth/components/auth-gate/auth-gate.component').then(
        (m) => m.AuthGateComponent
      ),
    loadChildren: () =>
      import('@domains/admin/routes/admin.routes').then((m) => m.adminRoutes),
  },
  {
    path: '',
    loadChildren: () =>
      import('@domains/public/routes/public.routes').then((m) => m.publicRoutes),
  },
  {
    path: '**',
    loadComponent: () =>
      import('@shared/components/not-found/not-found.component').then(
        (m) => m.NotFoundComponent
      ),
  },
];
